import React from 'react';

import { Box, Icon, Sheet, Table, Text } from '@betterment/samba-react';
import { format } from 'date-fns';

import { BulkFeeIntentBodyCell } from './BulkFeeIntentBodyCell';
import { BulkFeeIntentSheet } from './BulkFeeIntentSheet';
import { BulkFeeIntentStatusComponent } from './BulkFeeIntentStatusComponent';

import { BulkFeeIntentProps } from '../data';

const rowStyles = (isViewingFeeIntent: boolean) => ({
  width: '100%',
  transition: 'background-color 0.2s ease-in-out',
  backgroundColor: isViewingFeeIntent ? 'background.info' : 'background.transparent',
  '&:hover': {
    backgroundColor: 'background.info',
    cursor: 'pointer',
  },
});

export const BulkFeeIntentRow: React.FC<BulkFeeIntentProps> = ({ bulkFeeIntent }) => {
  const [isViewingFeeIntent, setIsViewingFeeIntent] = React.useState(false);

  const handleOpenSheet = () => {
    setIsViewingFeeIntent(true);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleOpenSheet();
    }
  };

  return (
    <>
      <Table.Row
        aria-label={`View details for ${bulkFeeIntent.name}`}
        onClick={handleOpenSheet}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        role="button"
        css={rowStyles(isViewingFeeIntent)}
        data-testid={`bulk-fee-intent-row-${bulkFeeIntent.id}`}
      >
        <BulkFeeIntentBodyCell pr={true} noWrap={true}>
          <Text as="span" color="text" variant="text100" css={{ fontWeight: '400' }}>
            {format(new Date(bulkFeeIntent.createdAt), 'MMM d, yyyy')}
          </Text>
        </BulkFeeIntentBodyCell>
        <BulkFeeIntentBodyCell pr={true}>
          <Box css={{ display: 'flex', flexDirection: 'column' }}>
            <Text as="span" color="text" variant="text100" css={{ fontWeight: '400' }}>
              {bulkFeeIntent.name}
            </Text>
            {bulkFeeIntent.createdBy?.name ? (
              <Text as="span" color="text.weak" variant="text50" css={{ fontWeight: '400' }}>
                Created by {bulkFeeIntent.createdBy?.name}
              </Text>
            ) : null}
          </Box>
        </BulkFeeIntentBodyCell>
        <BulkFeeIntentBodyCell pr={true} noWrap={true}>
          <BulkFeeIntentStatusComponent bulkFeeIntent={bulkFeeIntent} />
        </BulkFeeIntentBodyCell>
        <BulkFeeIntentBodyCell>
          <Box css={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Icon name="CaretRight" size="small" />
          </Box>
        </BulkFeeIntentBodyCell>
      </Table.Row>
      <Sheet overlay="weak" open={isViewingFeeIntent} onOpenChange={setIsViewingFeeIntent}>
        <Sheet.Content css={{ overflowY: 'auto' }} aria-describedby={undefined}>
          <BulkFeeIntentSheet bulkFeeIntent={bulkFeeIntent} />
        </Sheet.Content>
      </Sheet>
    </>
  );
};
